export const BE_NOT_FOUND = 'NOT_FOUND';
export const BE_INVALID_INPUT = 'INVALID_INPUT';
export const BE_UNEXPECTED_ERROR = 'UNEXPECTED_ERROR';

export type BusinessErrorType = typeof BE_NOT_FOUND | typeof BE_INVALID_INPUT | typeof BE_UNEXPECTED_ERROR;
